let value = null;
let appValues = null;

const fieldValidationHelper = (fieldValidator, app = null) => {
    let validator = {
        isValid: true,
        messages: '',
        invalidRules:[]
    };

    const rules = fieldValidator?.rules;
    if(typeof rules === 'undefined' || !rules) {
        return validator;
    }

    value = fieldValidator.value;
    appValues = app;

    // check for bogus data
    if(typeof value === 'string') {
    // if(typeof value !== 'boolean') {
        let valueAsArray = !!fieldValidator.value ? fieldValidator.value.replace(/\s+/g, ' ').toLowerCase().trim().split(' ') : [];
        let invalidValues = ['test','dsa','fdsa'];
        let filteredValues = invalidValues.filter(value => valueAsArray.includes(value));
        if(filteredValues.length>0) {
            validator.isValid = false;
            validator.messages = ['__invalid_data__'];
            return validator;
        }
    }

    let allRules = rules.split('|').filter(rule=>rule.length>0);

    allRules.forEach((rule,index)=> {
        var fxName = rule + 'Validation';
        try {
            if(typeof eval(fxName) === 'function') {
                if( !(eval(fxName + '()')) ) {
                    validator.isValid = false;
                    validator.invalidRules.push(rule);
                }
            }
        }
        catch(err) {}
    });

    validator.messages = getValidationMessages(validator.invalidRules);
    return validator;
}

const getValidationMessages = function getMessages(invalidRules = []) {
    let messages = [];
    if(invalidRules.length > 0) {
        invalidRules.forEach((rule,index)=> {
            switch(rule) {
                case 'email':
                    messages.push('__email_required__');
                    break;
                case 'emailConfirmation':
                    messages.push('__email_confirmation__');
                    break;
                case 'phone':
                    messages.push('__phone_format__');
                    break;
                case 'canadianPhone':
                    messages.push('__phone_canadian__');
                    break;
                case 'password':
                    messages.push('__password__');
                    break;
                case 'passwordConfirmation':
                    messages.push('__password_confirmation__');
                    break;
                case 'name':
                    messages.push('__name__');
                    break;
                case 'dob':
                    messages.push('__dob__');
                    break;
                case 'date':
                    messages.push('__date__');
                    break;
                case 'postal':
                case 'postalCode':
                    // messages.push('The postal code must be in format A9A9A9');
                    messages.push('__postal_code_format__');
                    break;
                case 'sin':
                    messages.push('__sin__');
                    break;
                case 'city':
                case 'street':
                    messages.push('__invalid_character__');
                    break;
                case 'numeric':
                    messages.push('__numeric__');
                    break;
                case 'driversLicense':
                    messages.push('__drivers_license__');
                    break;
                default:
                    messages.unshift('__required_field__');
                    break;
            }
        });
    }
    return messages;
}

const addressFieldValidationHelper = (addressValue) => {

    let validator = {
        isValid: false,
        messages: ['__address_required__'],
        invalidFields:[]
    };

    if(typeof addressValue === undefined || !addressValue) {
        return validator;
    }

    const addressFieldsRules = {
        street: 'required',
        streetNumber: 'required',
        postalCode: 'required|postal',
        province: 'required|canadianProvince',
        city: 'required',
    };

    Object.keys(addressValue).forEach((field,index)=> {
        if( addressFieldsRules.hasOwnProperty(field) ) {
            let allRules = addressFieldsRules[field].split('|').filter(rule=>rule.length>0);
            value = addressValue[field] ?? '';
            allRules.forEach((rule,index)=> {
                var fxName = rule + 'Validation';
                try {
                    if(typeof eval(fxName) === 'function') {
                        if( !(eval(fxName + '()')) ) {
                            validator.invalidFields.push(field);
                        }
                    }
                }
                catch(err) {}
            });
        }
    });

    validator.isValid = validator.invalidFields.length === 0;
    validator.messages = validator.isValid ? [] : ['__address_required__'];
    return validator;
}

function requiredValidation() {
    return typeof value === 'boolean' ? !!value : (!!value && value.replace(/\s+/g, ' ').trim().length>0 && value.length<255);
}

function nameValidation() {

    if(!value) {
        return false;
    }

    let name = value.replace(/\s+/g, ' ').trim();
    let regexCheck = (/^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s-]*)$/.test(name));

    return name.length > 1 && name.length<255 && regexCheck;
}

function phoneValidation() {
    // validating phone number:
    //  --  has to be 10 digits
    //  -- cant start with number 1
    if(!value || /^[2-9]\d{9}$/.test(value)) {
        return true;
    }
    return false;
}

function passwordValidation() {
    let regexCheck = (/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(value));
    return regexCheck;
}

function passwordConfirmationValidation() {
    // requires passwordValidation()
    return passwordValidation() && appValues && appValues.password == value;
}

function emailConfirmationValidation() {
    // requires emailValidation()
    return emailValidation() && appValues && appValues.email == value;
}

function dobValidation() {
    return !!value && value.length==10;
}

function emailValidation() {
    if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(value)) {
        let username = value.toLowerCase().split('@')[0];
        let tld = value.toLowerCase().substring(value.indexOf('@') + 1).split('.')[0];
        let  emailTypos = ['getnada','test','email','mail','otmail','htmail','homail','hotail','hotmil','hotmal','hotmai','hhotmail','hootmail','hottmail','hotmmail','hotmaail','hotmaiil','hotmaill','ohtmail','htomail','homtail','hotamil','hotmial','hotmali','gotmail','yotmail','uotmail','jotmail','notmail','botmail','hitmail','h9tmail','h0tmail','hptmail','hltmail','hktmail','hormail','ho5mail','ho6mail','hoymail','hohmail','hogmail','hofmail','hotnail','hotjail','hotkail','hotmqil','hotmwil','hotmsil','hotmxil','hotmzil','hotmaul','hotma8l','hotma9l','hotmaol','hotmall','hotmakl','hotmajl','hotmaik','hotmaio','hotmaip','ghotmail','hgotmail','yhotmail','hyotmail','uhotmail','huotmail','jhotmail','hjotmail','nhotmail','hnotmail','bhotmail','hbotmail','hiotmail','hoitmail','h9otmail','ho9tmail','h0otmail','ho0tmail','hpotmail','hoptmail','hlotmail','holtmail','hkotmail','hoktmail','hortmail','hotrmail','ho5tmail','hot5mail','ho6tmail','hot6mail','hoytmail','hotymail','hohtmail','hothmail','hogtmail','hotgmail','hoftmail','hotfmail','hotnmail','hotmnail','hotjmail','hotmjail','hotkmail','hotmkail','hotmqail','hotmaqil','hotmwail','hotmawil','hotmsail','hotmasil','hotmxail','hotmaxil','hotmzail','hotmazil','hotmauil','hotmaiul','hotma8il','hotmai8l','hotma9il','hotmai9l','hotmaoil','hotmaiol','hotmalil','hotmaill','hotmakil','hotmaikl','hotmajil','hotmaijl','hotmaikl','hotmailk','hotmaiol','hotmailo','hotmaipl','hotmailp','utlook','otlook','oulook','outook','outlok','outlok','outloo','ooutlook','ouutlook','outtlook','outllook','outloook','outloook','outlookk','uotlook','otulook','oultook','outolok','outloko','iutlook','9utlook','0utlook','putlook','lutlook','kutlook','oytlook','o7tlook','o8tlook','oitlook','oktlook','ojtlook','ohtlook','ourlook','ou5look','ou6look','ouylook','ouhlook','ouglook','ouflook','outkook','outoook','outpook','outliok','outl9ok','outl0ok','outlpok','outllok','outlkok','outloik','outlo9k','outlo0k','outlopk','outlolk','outlokk','outlooj','outlooi','outlooo','outlool','outloom','ioutlook','oiutlook','9outlook','o9utlook','0outlook','o0utlook','poutlook','oputlook','loutlook','olutlook','koutlook','okutlook','oyutlook','ouytlook','o7utlook','ou7tlook','o8utlook','ou8tlook','oiutlook','ouitlook','okutlook','ouktlook','ojutlook','oujtlook','ohutlook','ouhtlook','ourtlook','outrlook','ou5tlook','out5look','ou6tlook','out6look','ouytlook','outylook','ouhtlook','outhlook','ougtlook','outglook','ouftlook','outflook','outklook','outlkook','outolook','outloook','outplook','outlpook','outliook','outloiok','outl9ook','outlo9ok','outl0ook','outlo0ok','outlpook','outlopok','outllook','outlolok','outlkook','outlokok','outloiok','outlooik','outlo9ok','outloo9k','outlo0ok','outloo0k','outlopok','outloopk','outlolok','outloolk','outlokok','outlookk','outloojk','outlookj','outlooik','outlooki','outloook','outlooko','outloolk','outlookl','outloomk','outlookm','mail','gail','gmil','gmal','gmai','ggmail','gmmail','gmaail','gmaiil','gmaill','mgail','gamil','gmial','gmali','fmail','tmail','ymail','hmail','bmail','vmail','gnail','gjail','gkail','gmqil','gmwil','gmsil','gmxil','gmzil','gmaul','gma8l','gma9l','gmaol','gmall','gmakl','gmajl','gmaik','gmaio','gmaip','fgmail','gfmail','tgmail','gtmail','ygmail','gymail','hgmail','ghmail','bgmail','gbmail','vgmail','gvmail','gnmail','gmnail','gjmail','gmjail','gkmail','gmkail','gmqail','gmaqil','gmwail','gmawil','gmsail','gmasil','gmxail','gmaxil','gmzail','gmazil','gmauil','gmaiul','gma8il','gmai8l','gma9il','gmai9l','gmaoil','gmaiol','gmalil','gmaill','gmakil','gmaikl','gmajil','gmaijl','gmaikl','gmailk','gmaiol','gmailo','gmaipl','gmailp','ol','al','ao','aaol','aool','aoll','oal','alo','qol','wol','sol','xol','zol','ail','a9l','a0l','apl','all','akl','aok','aoo','aop','qaol','aqol','waol','awol','saol','asol','xaol','axol','zaol','azol','aiol','aoil','a9ol','ao9l','a0ol','ao0l','apol','aopl','alol','aoll','akol','aokl','aokl','aolk','aool','aolo','aopl','aolp','ahoo','yhoo','yaoo','yaho','yaho','yyahoo','yaahoo','yahhoo','yahooo','yahooo','ayhoo','yhaoo','yaoho','tahoo','6ahoo','7ahoo','uahoo','jahoo','hahoo','gahoo','yqhoo','ywhoo','yshoo','yxhoo','yzhoo','yagoo','yayoo','yauoo','yajoo','yanoo','yaboo','yahio','yah9o','yah0o','yahpo','yahlo','yahko','yahoi','yaho9','yaho0','yahop','yahol','yahok','tyahoo','ytahoo','6yahoo','y6ahoo','7yahoo','y7ahoo','uyahoo','yuahoo','jyahoo','yjahoo','hyahoo','yhahoo','gyahoo','ygahoo','yqahoo','yaqhoo','ywahoo','yawhoo','ysahoo','yashoo','yxahoo','yaxhoo','yzahoo','yazhoo','yaghoo','yahgoo','yayhoo','yahyoo','yauhoo','yahuoo','yajhoo','yahjoo','yanhoo','yahnoo','yabhoo','yahboo','yahioo','yahoio','yah9oo','yaho9o','yah0oo','yaho0o','yahpoo','yahopo','yahloo','yaholo','yahkoo','yahoko','yahoio','yahooi','yaho9o','yahoo9','yaho0o','yahoo0','yahopo','yahoop','yaholo','yahool','yahoko','yahook','netetrt'];
        if(!['test','dsa','fdsa','mail','email'].includes(username) && !emailTypos.includes(tld)) {
            return true;
        }
    }
    return false;
}

function sinValidation() {
    if(!value || /^\d{9}$/.test(value)) {
        return true;
    }
    return false;
}

function cityValidation() {
    let city = value.replace(/\s+/g, ' ').trim();
    let regexCheck = (/^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s-&().']*)$/.test(city));

    return city.length > 1 && city.length<255 && regexCheck;
}

function streetValidation() {
    let street = value.replace(/\s+/g, ' ').trim();
    let regexCheck = (/^([0-9A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s-,#.&()']*)$/.test(street));
    return regexCheck;
}

function postalValidation() {
    let regexCheck = (/^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ][ -]?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i.test(value));
    return regexCheck;
}

function numericValidation() {
    let regexCheck = (/^[0-9]*$/.test(value));
    return regexCheck;
}

function canadianPhoneValidation(phoneNumber = null, finalValidation = true) {

    phoneNumber = phoneNumber ? phoneNumber : value;

    const invalidAreaCodes = [
        // Alabama
        205, 251, 256, 334, 659, 938,
        // Alaska
        907,
        // Arizona
        480, 520, 602, 623, 928,
        // Arkansas
        479, 501, 870,
        // California
        209, 213, 279, 310, 323, 341, 350, 408, 415, 424, 442, 510, 530, 559, 562, 619, 626, 628, 650, 657, 661, 669, 707, 714, 747, 760, 805, 818, 820, 831, 840, 858, 909, 916, 925, 949, 951,
        // Colorado
        303, 719, 720, 970, 983,
        // Connecticut
        203, 475, 860, 959,
        // Delaware
        302,
        // Florida
        239, 305, 321, 352, 386, 407, 448, 561, 656, 689, 727, 754, 772, 786, 813, 850, 863, 904, 941, 954,
        // Georgia
        229, 404, 470, 478, 678, 706, 762, 770, 912, 943,
        // Hawaii
        808,
        // Idaho
        208, 986,
        // Illinois
        217, 224, 309, 312, 331, 447, 464, 618, 630, 708, 773, 779, 815, 847, 872,
        // Indiana
        219, 260, 317, 463, 574, 765, 812, 930,
        // Iowa
        319, 515, 563, 641, 712,
        // Kansas
        316, 620, 785, 913,
        // Kentucky
        270, 364, 502, 606, 859,
        // Louisiana
        225, 318, 337, 504, 985,
        // Maine
        207,
        // Maryland
        240, 301, 410, 443, 667,
        // Massachusetts
        339, 351, 413, 508, 617, 774, 781, 857, 978,
        // Michigan
        231, 248, 269, 313, 517, 586, 616, 734, 810, 906, 947, 989,
        // Minnesota
        218, 320, 507, 612, 651, 763, 952,
        // Mississippi
        228, 601, 662, 769,
        // Missouri
        314, 417, 557, 573, 636, 660, 816,
        // Montana
        406,
        // Nebraska
        308, 402, 531,
        // Nevada
        702, 725, 775,
        // New Hampshire
        603,
        // New Jersey
        201, 551, 609, 640, 732, 848, 856, 862, 908, 973,
        // New Mexico
        505, 575,
        // New York
        212, 315, 332, 347, 363, 516, 518, 585, 607, 631, 646, 680, 716, 718, 838, 845, 914, 917, 929, 934,
        // North Carolina
        252, 336, 472, 704, 743, 828, 910, 919, 980, 984,
        // North Dakota
        701,
        // Ohio
        216, 220, 234, 326, 330, 380, 419, 440, 513, 567, 614, 740, 937,
        // Oklahoma
        405, 539, 572, 580, 918,
        // Oregon
        458, 503, 541, 971,
        // Pennsylvania
        215, 223, 267, 272, 412, 445, 484, 570, 582, 610, 717, 724, 814, 835, 878,
        // Rhode Island
        401,
        // South Carolina
        803, 839, 843, 854, 864,
        // South Dakota
        605,
        // Tennessee
        423, 615, 629, 731, 865, 901, 931,
        // Texas
        210, 214, 254, 281, 325, 346, 361, 409, 430, 432, 469, 512, 682, 713, 726, 737, 806, 817, 830, 832, 903, 915, 936, 940, 945, 956, 972, 979,
        // Utah
        385, 435, 801,
        // Vermont
        802,
        // Virginia
        276, 434, 540, 571, 703, 757, 804, 826, 948,
        // Washington
        206, 253, 360, 425, 509, 564,
        // Washington, DC
        202, 771,
        // West Virginia
        304, 681,
        // Wisconsin
        262, 414, 534, 608, 715, 920,
        // Wyoming
        307,
    ];

    const tollFreeAreaCodes = [
        800, 833, 844, 855, 866, 877, 888,
    ];

    let invalidPhoneStart = Array.from(new Set(invalidAreaCodes.concat(tollFreeAreaCodes)));

    if( phoneNumber && phoneNumber.length >= 3 ) {
        if(phoneNumber.startsWith(1) || invalidPhoneStart.some(areaCode => phoneNumber.startsWith(areaCode))) {
            return false;
        }
    }

    if(finalValidation) {
        const regex = /^\d{10}$/;
        if(!regex.test(phoneNumber)) {
            return false;
        }
    }

    return true;
}

function driversLicenseValidation() {
    return !!value && value.length>0 && value=='yes';
}

function canadianProvinceValidation() {
    let validProvinces = ['AB','BC','MB','NB','NL','NS','NT','NU','ON','PE','QC','SK','YT'];
    return !!value && value.length===2 && validProvinces.includes(value);
}

export { fieldValidationHelper, addressFieldValidationHelper, canadianPhoneValidation, getValidationMessages }
